export const GET_PROCTOR_LIST = `query getProctorList {
  auth_user(where: {roles: {role: {_eq: PROCTOR}}}) {
    id
    name
    email
  }
}`;
